import { Box, Hidden } from 'braid-design-system';

import DesktopMessage from './components/DesktopMessage/DesktopMessage';
import MobileMessage from './components/MobileMessage/MobileMessage';

const SellingAFranchise = () => (
  <Box
    background="positiveLight"
    padding={{ mobile: 'medium', tablet: 'xlarge' }}
    borderRadius="large"
    position="relative"
  >
    <Hidden below="tablet">
      <DesktopMessage />
    </Hidden>

    <Hidden above="mobile">
      <MobileMessage />
    </Hidden>
  </Box>
);

export default SellingAFranchise;
